/*
 Support for separated icons will be added in antd future releases

 WIP pull request:  https://github.com/ant-design/ant-design/pull/12888
 Github issue:  https://github.com/ant-design/ant-design/issues/12011

 This is a workaround for current version of antd
 This file defines only icons that are in use. Other icons won't go to the production bundle.
*/

// used in form inputs to show success validation
export { default as CheckCircleFill } from '@ant-design/icons/lib/fill/CheckCircleFill'

// used in UFORadioButton
export { default as CheckOutline } from '@ant-design/icons/lib/outline/CheckOutline'

// used in modals and notifications (close X button)
export { default as CloseOutline } from '@ant-design/icons/lib/outline/CloseOutline'

// used on trips page (tap to select button)
export { default as CaretUpOutline } from '@ant-design/icons/lib/outline/CaretUpOutline'

// used on trips page (drawer header)
export { default as ArrowLeftOutline } from '@ant-design/icons/lib/outline/ArrowLeftOutline'

// used in error notifications
export { default as ExclamationCircleOutline } from '@ant-design/icons/lib/outline/ExclamationCircleOutline'

// used in Location component
export { default as InfoCircleOutline } from '@ant-design/icons/lib/outline/InfoCircleOutline'

// used in BackButton
export { default as LeftOutline } from '@ant-design/icons/lib/outline/LeftOutline'

// used in input loading spinners (VoucherInput, ParnterCodeInput) and in NextStepButton
export { default as LoadingOutline } from '@ant-design/icons/lib/outline/LoadingOutline'

// used in SearchInput
export { default as SearchOutline } from '@ant-design/icons/lib/outline/SearchOutline'

// used in trips for "show chargers" button
export { default as ThunderboltOutline } from '@ant-design/icons/lib/outline/ThunderboltOutline'

// used in trips for "Refresh" button
export { default as ReloadOutline } from '@ant-design/icons/lib/outline/ReloadOutline'
